module.exports = __webpack_public_path__ + "img/card_img_content.c570ea16.png";